











# This component determines how many columns are shown on screen

import TheMovies from '@/components/TheMovies'

export default
    components: { TheMovies }
    data: ->
        width: 0
        height: 0
        column_min_width: 400
        row_height: 17
        dragging: false

    computed:
        num_columns: ->
            return Math.max(1, Math.floor(@width / @column_min_width))
        num_rows: ->
            return Math.max(1, Math.floor(@height / @row_height) - 1)

    created: ->
        window.addEventListener('resize', @computeDivSize)
        window.addEventListener('keydown', @keyhandler)
        window.addEventListener('wheel', @scrollhandler)

    mounted: ->
        @computeDivSize()

    destroyed: ->
        window.removeEventListener('resize', @computeDivSize)
        window.removeEventListener('keydown', @keyhandler)
        window.removeEventListener('wheel', @scrollhandler)

    watch:
        '$route.path': ->
            @computeDivSize()

    methods:
        elementHasParentId: (el, parent_id) ->
            while el and el.id != 'theTop'
                if el.id == parent_id
                    return true
                el = el.parentNode

        computeDivSize: ->
            div = document.getElementById('movieHolder')
            rect = div.getBoundingClientRect()
            @width = rect.width

            rect = document.body.getBoundingClientRect()
            slider_height = 80
            header_height = 25
            if @$store.state.display.group_by_year
                @height = rect.height - header_height - slider_height
            else
                @height = rect.height - header_height

        keyhandler: (event) ->
            if event.key == "ArrowLeft"
                @move('horizontal', 1)
                # event.preventDefault()
            if event.key == "ArrowRight"
                @move('horizontal', -1)
                # event.preventDefault()
            if event.key == "ArrowUp"
                @move('vertical', -1)
                event.preventDefault()
            if event.key == "ArrowDown"
                @move('vertical', 1)
                event.preventDefault()
            if event.key == "PageUp"
                @move('vertical', -@num_rows)
                event.preventDefault()
            if event.key == "PageDown"
                @move('vertical', @num_rows)
                event.preventDefault()

        scrollhandler: (event) ->
            if event.deltaY != 0
                dir = if event.deltaY < 0 then -1 else 1
                if @elementHasParentId(event.target, 'theYearSlider')
                    @move('horizontal', -dir)
                if @elementHasParentId(event.target, 'theItemsHolder')
                    @move('vertical', dir * 6)
                    # event.stopImmediatePropagation()
                    # event.preventDefault()

        move: (orientation, amount) ->
            if orientation == 'horizontal'
                year = @$store.state.display.year + amount
                @$store.commit('display/SET_YEAR', year)
            if orientation == 'vertical'
                topindex = @$store.state.display.topindex + amount
                @$store.commit('display/SET_TOPINDEX', topindex)

        startDrag: (event) ->
            @dragging = true if event.button == 1
        doDrag: (event) ->
            if @dragging
                @move('vertical', event.movementY)
        stopDrag: (event) ->
            @dragging = false if event.button == 1


